import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const defaultStyles = {
    informationAtGlanceArea: {
      width: '100%',
      fontFamily: FONT_FAMILY
    },
    barTitle: {
      fontSize: '18px',
      fontWeight: '700',
      marginBottom: 5,
      color: colors.approxBlack
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      width: '100%'
    },
    noPadding: {
      padding: '10px 0'
    },
    informationAtGlanceItem: {
      textAlign: 'center',
      cursor: 'pointer'
    },
    informationAtGlanceItemText: {
      fontSize: '14px',
      fontWeight: '500',
      color: colors.primary,
      marginTop: '10px'
    },
    uncomingContainer: {
      display: 'flex'
    },
    medicationsContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    testResultsContainer: {
      display: 'flex',
      justifyContent: 'end'
    }
  }
  return defaultStyles
}

export default themeStyles
